import React, { Fragment, useState, useMemo } from "react";

import departmentZh from "./assets/tag/department_zh.png";
import departmentEn from "./assets/tag/department_en.png";
import approveZh from "./assets/tag/approve_zh.png";
import approveEn from "./assets/tag/approve_en.png";
import externalZh from "./assets/tag/external_zh.png";
import externalEn from "./assets/tag/external_en.png";
import squadZh from "./assets/tag/squad_zh.png";
import squadEn from "./assets/tag/squad_en.png";
import robotZh from "./assets/tag/robot_zh.png";
import robotEn from "./assets/tag/robot_en.png";

import { isEN } from "../../_util/locale";
import { validProtocolReg, TeamType, tagDomain } from "./utils";

interface ITag {
  type?: number | string; // 群类型，参考 TeamType

  onlyShowSystemTag?: boolean; // 仅展示系统默认群：部门群、审批群
  maxCount?: number; // 最多展示标签数量

  isSquad?: boolean; // 话题群

  isExternal?: boolean; // 外部群

  tagImgName?: string; // 控制模版群中文
  tagImgEnName?: string; // 控制模版群英文

  wrapStyle?: any; // 父容器样式
  customStyle?: any; // 图片样式

  groupTags?: {
    icon_zh: string;
    icon_en: string;
  }[]; // 群标签
}

interface IGroupTempateProps {
  tagImgName: string;
  tagImgEnName: string;
  customStyle?: any;
}
interface ICalendarTagProps {
  groupTags: {
    icon_zh: string;
    icon_en: string;
  }[];
  customStyle?: any;
}

const GroupTemplate = (props: IGroupTempateProps) => {
  const [loadError, setLoadError] = useState(false);

  const onError = () => {
    setLoadError(true);
  };

  const urlOrName = isEN() ? props.tagImgEnName : props.tagImgName;
  const url = validProtocolReg(urlOrName) ? urlOrName : "";

  return url && !loadError ? (
    <img
      src={url}
      onError={onError}
      className="tag groupTemplateTag "
      style={props.customStyle}
      draggable={false}
    />
  ) : null;
};

const CalendarTag = (props: ICalendarTagProps) => {
  const [loadError, setLoadError] = useState(false);

  const onError = () => {
    setLoadError(true);
  };

  // 使用 useMemo 缓存整个计算过程
  const url = useMemo(() => {
    const tagName = isEN()
      ? props.groupTags?.[0]?.icon_en
      : props.groupTags?.[0]?.icon_zh;
    const tagUrl = tagDomain + tagName;
    return validProtocolReg(tagUrl) ? tagUrl : "";
  }, [props.groupTags]);

  return url && !loadError ? (
    <img
      src={url}
      onError={onError}
      className="tag calendarTag "
      style={props.customStyle}
      draggable={false}
    />
  ) : null;
};

const PoolTag = (props: ITag) => {
  const {
    type,

    onlyShowSystemTag = false,
    maxCount = 1,

    isSquad = false,

    isExternal = false,

    tagImgEnName = "",
    tagImgName = "",

    wrapStyle,
    customStyle,
    groupTags = [],
  } = props;

  let innerJSXArr: JSX.Element[] = [];

  if (type == TeamType.departmentTeam) {
    innerJSXArr.push(
      <img
        src={isEN() ? departmentEn : departmentZh}
        className="tag"
        style={customStyle}
      />
    );
  } else if (type == TeamType.approvalTeam) {
    innerJSXArr.push(
      <img
        src={isEN() ? approveEn : approveZh}
        className="tag"
        style={customStyle}
      />
    );
  } else if (type == TeamType.calendarTeam && groupTags?.length) {
    innerJSXArr.push(
      <CalendarTag groupTags={groupTags} customStyle={customStyle} />
    );
  } else if (type == 202) {
    innerJSXArr.push(
      <img
        src={isEN() ? robotEn : robotZh}
        className="tag"
        style={{ ...customStyle, width: "50px" }}
      />
    );
  } else if (!onlyShowSystemTag) {
    if (isSquad) {
      innerJSXArr.push(
        <img
          src={isEN() ? squadEn : squadZh}
          className="tag"
          style={customStyle}
        />
      );
    } else {
      if (tagImgName && tagImgEnName) {
        innerJSXArr.push(
          <GroupTemplate
            customStyle={customStyle}
            tagImgName={tagImgName}
            tagImgEnName={tagImgEnName}
          />
        );
      }
    }

    if (isExternal)
      innerJSXArr.push(
        <img
          src={isEN() ? externalEn : externalZh}
          className="tag"
          style={customStyle}
        />
      );
  }

  innerJSXArr = innerJSXArr.slice(0, maxCount);

  if (innerJSXArr?.length) {
    return (
      <div className="wrapTag" style={wrapStyle}>
        {innerJSXArr.map((jsx, index) => {
          return <Fragment key={index}>{jsx}</Fragment>;
        })}
      </div>
    );
  }

  return null;
};

export default PoolTag;
//ci
